import { useEffect } from 'react'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en/en.json'
import tr from './tr/tr.json'
import ar from './ar/ar.json'

import 'moment/locale/tr'
import 'moment/locale/en-gb'
import moment from 'moment'
import { useAppSelector } from 'app/hooks'

export const resources = {
  en: { translation: en },
  tr: { translation: tr },
  ar: { translation: ar },
}

// i18n başlangıç yapılandırması
i18n.use(initReactI18next).init({
  debug: false,
  fallbackLng: 'tr',
  resources,
  returnNull: false,
})

// **Dil Güncelleyici Bileşen**
export default function I18nConfig() {
  const notificationLanguage = useAppSelector((state) => state.auth?.user?.notificationLanguage) || 'tr'

  // RTL ayarlarını uygulayan yardımcı fonksiyon
  const applyRTLSettings = (language: string) => {
    const body = document.body
    const html = document.documentElement
    
    if (language === 'ar') {
      body.style.direction = 'rtl'
      body.classList.add('rtl')
      html.setAttribute('dir', 'rtl')
      html.setAttribute('lang', 'ar')
    } else {
      body.style.direction = 'ltr'
      body.classList.remove('rtl')
      html.setAttribute('dir', 'ltr')
      html.setAttribute('lang', language)
    }
  }

  useEffect(() => {
    const locale = `${notificationLanguage}-${notificationLanguage.toUpperCase()}`
    
    moment.locale(locale)
    i18n.changeLanguage(notificationLanguage)
    
    // RTL ayarlarını uygula
    applyRTLSettings(notificationLanguage)
  }, [notificationLanguage])

  // Sayfa yüklendiğinde de RTL ayarlarını uygula
  useEffect(() => {
    applyRTLSettings(notificationLanguage)
  }, [])

  return null // Render edilmeyen, sadece dili güncelleyen bileşen
}
